import { useSyncExternalStore } from 'react';
import type { ShareFiltersInput } from '@frameio/graphql-client/generated';
import { appComponentsStorage } from '@frameio/shared/storage';

const STORAGE_KEY = 'frame-io--shares-filter-by';
const DEFAULT_FILTER_BY: ShareFiltersInput = {
  aggregationMode: undefined,
  /** Filter shares by creator user ID */
  creatorId: undefined,
  name: undefined,
  origin: undefined,
};

function createGetSnapshot() {
  let cachedValue: ShareFiltersInput | null = null;

  return () => {
    const currentValue =
      appComponentsStorage.get(STORAGE_KEY) || DEFAULT_FILTER_BY;

    if (
      !cachedValue ||
      cachedValue.aggregationMode !== currentValue.aggregationMode ||
      cachedValue.creatorId !== currentValue.creatorId ||
      cachedValue.name !== currentValue.name ||
      cachedValue.origin !== currentValue.origin
    ) {
      cachedValue = currentValue;
    }

    return cachedValue;
  };
}

const store = {
  subscribe: (callback: () => void) => {
    window.addEventListener('storage', callback);
    return () => window.removeEventListener('storage', callback);
  },

  snapshot: createGetSnapshot(),
};

export function useSharesFilterBy() {
  const filterBy = useSyncExternalStore(
    store.subscribe,
    store.snapshot,
    () => DEFAULT_FILTER_BY
  );

  const updateFilterBy = (newFilterBy: ShareFiltersInput) => {
    appComponentsStorage.set(STORAGE_KEY, newFilterBy);
    window.dispatchEvent(new StorageEvent('storage', { key: STORAGE_KEY }));
  };

  return [filterBy, updateFilterBy] as const;
}
